import { useTranslation } from 'react-i18next';

import { FormField, IAutocompleteProps } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { corporateService } from 'corporate/services';

export const ShipmentTypeFormField = ({ label, ...props }: IAutocompleteProps) => {
  const { t } = useTranslation();

  const { control, errors } = useFormContext();

  return (
    <FormField
      name="shipmentType"
      type={InputType.AUTOCOMPLETE}
      inputProps={{
        control,
        error: errors?.shipmentType,
        label: label === undefined ? t('labelShipmentType') : label,
        placeholder: t('placeholderUpsertLineShipmentType'),
        getOptions: corporateService.getShipmentTypeAutocomplete,
        disableClearable: true,
        required: true,
        enabledOnFocus: false,
        ...props,
      }}
    />
  );
};
